import { type ExamCenterProctorRequestFragment } from '@exam-center/graphql';
import { type PropsWithChildren, zodResolver } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  examCenterProctorRequestVerdictFormSchema,
  type ExamCenterProctorRequestVerdictFormType,
} from './schema';

interface ExamCenterProctorRequestVerdictFormProviderProps extends PropsWithChildren {
  initialValues?: ExamCenterProctorRequestFragment;
}

export default function ExamCenterProctorRequestVerdictFormProvider(
  props: Readonly<ExamCenterProctorRequestVerdictFormProviderProps>,
) {
  const { children, initialValues } = props;

  const verdict = initialValues?.verdicts.find((verdict) => verdict.submittedAt === null);
  const formContext = useForm<ExamCenterProctorRequestVerdictFormType>({
    resolver: zodResolver(examCenterProctorRequestVerdictFormSchema),
    defaultValues: {
      verdict: verdict?.verdict ?? undefined,
      comment: verdict?.comment ?? '',
      action: 'save',
    },
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
